const api_prefix = "/api/";
const ws_prefix = "/ws/";

const api_urls = {
    user: "user",
    login: "user/login",
    logout: "user/logout",
    signup: "user/signup",
    unregister: "user/withdraw",
    emailConfirm: "user/email/confirm",
    resetPassword: "user/reset/password",
    changePassword: "user/change/password",
    changeMarketing: "user/change/marketing",
    changeEnvSettings: "user/change/env-settings",
    googleLogin: "user/social/google/",
    naverLogin: "user/social/naver/",
    adminChangeUser: "user/admin/change/user",
    exitSurvey: "user/survey/WITHDRAWAL_SURVEY",

    note: "note",
    noteCreateWithMarkdown: "note/convert-md",
    noteAsset: "note/asset",
    selectBoxOptions: "common/select-box-options",

    // payment
    paymentBillingKey: "payment/billing/key",
    paymentPlan: "payment/plan",
    paymentCoupon: "payment/coupon",
    paymentCouponRegister: "payment/coupon/register",
    paymentDiscountPolicy: "payment/discount/policy",

    // search
    searchPapers: "search/papers",
    searchRecommendation: "search/papers/recommendation",
    searchPaperDetail: "search/papers/detail",
    searchRelatedPapers: "search/papers/related-papers",
    searchHistory: "search/history",

    // reference
    reference: "reference",
    referenceFile: "reference/file",
    referenceAddWithBibtex: "reference/add-with-bibtex",
    referenceAddFromSource: "reference/add-from-source",
    referenceStyle: "reference/style",
    referenceReview: "reference/review",
    tag: "reference/tag",
    folder: "reference/folder",

    // space
    space: "space",
    volume: "user/volume",
    manuscript: "manuscript",
    manuscriptTemplate: "manuscript/template",
};

const sse_url = {
    sseReferenceSummarize: "sse/reference/summarize",
};

const ws_urls = {
    referenceReview: "reference/review",
    search: "search",
    referenceAnalysis: "reference/analysis",
};

export function apiUrl(url) {
    return window.location.protocol + "//" + process.env.REACT_APP_API_BASE_URL + api_prefix + api_urls[url];
}

export function apiSpaceUrl(url, spaceUuid) {
    if (!spaceUuid) {
        throw new Error("spaceUuid is required");
    }
    return (
        window.location.protocol +
        "//" +
        process.env.REACT_APP_API_BASE_URL +
        api_prefix +
        `space/${spaceUuid}/` +
        api_urls[url]
    );
}

export function sseUrl(url) {
    return window.location.protocol + "//" + process.env.REACT_APP_API_BASE_URL + api_prefix + sse_url[url];
}

export function wsUrl(url) {
    const protocol = window.location.protocol === "https:" ? "wss://" : "ws://";

    return (
        protocol +
        process.env.REACT_APP_API_BASE_URL +
        ws_prefix +
        ws_urls[url] +
        `?token=${localStorage.getItem("token")}`
    );
}

export function wsManuscriptDocumentUrl(spaceUuid, manuscriptId, nodeId) {
    const protocol = window.location.protocol === "https:" ? "wss://" : "ws://";

    return (
        protocol +
        process.env.REACT_APP_API_BASE_URL +
        ws_prefix +
        `manuscript/${spaceUuid}/${manuscriptId}/documents/${nodeId}` +
        `?token=${localStorage.getItem("token")}`
    );
}

export function wsManuscriptEventUrl(spaceUuid, manuscriptId) {
    const protocol = window.location.protocol === "https:" ? "wss://" : "ws://";

    return (
        protocol +
        process.env.REACT_APP_API_BASE_URL +
        ws_prefix +
        `manuscript/${spaceUuid}/${manuscriptId}` +
        `?token=${localStorage.getItem("token")}`
    );
}

export function wsNoteDocumentUrl(spaceUuid) {
    const protocol = window.location.protocol === "https:" ? "wss://" : "ws://";

    return (
        protocol +
        process.env.REACT_APP_API_BASE_URL +
        ws_prefix +
        `note/${spaceUuid}/documents` +
        `?token=${localStorage.getItem("token")}`
    );
}

export function wsNoteAIEditUrl(spaceUuid, noteNo) {
    const protocol = window.location.protocol === "https:" ? "wss://" : "ws://";

    return (
        protocol +
        process.env.REACT_APP_API_BASE_URL +
        ws_prefix +
        `note/${spaceUuid}/${noteNo}/ai-edit` +
        `?token=${localStorage.getItem("token")}`
    );
}

export function wsNoteReviewAIUrl(spaceUuid, noteNo) {
    const protocol = window.location.protocol === "https:" ? "wss://" : "ws://";

    return (
        protocol +
        process.env.REACT_APP_API_BASE_URL +
        ws_prefix +
        `note/${spaceUuid}/${noteNo}/review-ai` +
        `?token=${localStorage.getItem("token")}`
    );
}

export function wsManuscriptAIEditUrl(spaceUuid, manuscriptId, nodeId) {
    const protocol = window.location.protocol === "https:" ? "wss://" : "ws://";

    return (
        protocol +
        process.env.REACT_APP_API_BASE_URL +
        ws_prefix +
        `manuscript/${spaceUuid}/${manuscriptId}/documents/${nodeId}/ai-edit` +
        `?token=${localStorage.getItem("token")}`
    );
}

export function wsManuscriptMathOCRUrl(spaceUuid, manuscriptId, nodeId) {
    const protocol = window.location.protocol === "https:" ? "wss://" : "ws://";

    return (
        protocol +
        process.env.REACT_APP_API_BASE_URL +
        ws_prefix +
        `manuscript/${spaceUuid}/${manuscriptId}/documents/${nodeId}/math-ocr` +
        `?token=${localStorage.getItem("token")}`
    );
}

export function wsManuscriptLatexErrorFixUrl(spaceUuid, manuscriptId, nodeId) {
    const protocol = window.location.protocol === "https:" ? "wss://" : "ws://";

    return (
        protocol +
        process.env.REACT_APP_API_BASE_URL +
        ws_prefix +
        `manuscript/${spaceUuid}/${manuscriptId}/documents/${nodeId}/latex-error-fix` +
        `?token=${localStorage.getItem("token")}`
    );
}

export function wsManuscriptReviewAIUrl(spaceUuid, manuscriptId) {
    const protocol = window.location.protocol === "https:" ? "wss://" : "ws://";

    return (
        protocol +
        process.env.REACT_APP_API_BASE_URL +
        ws_prefix +
        `manuscript/${spaceUuid}/${manuscriptId}/review-ai` +
        `?token=${localStorage.getItem("token")}`
    );
}
